import { defineParams } from '@sveltejs/kit/params';

export const params = defineParams({
  daily_mode: (param: string) =>
    param === 'daily' || param === 'mini' ? param : undefined,
});
